<template>
  <div class="hotspot" :style="positioningSpot" @click="goToContent">
    <a :href="enlace"><i :class="classType"></i></a>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'HotSpot',
  props: {
    indice: Number,
    x: Number,
    y: Number,
    ambient: Boolean,
    content: Number,
    type: String,
    ancho: Number,
    alto: Number,
    finalW: Number,
    finalH: Number,
    w: Number,
    h: Number,
    image: String,
    category: String,
    enlace: String
  },
  computed: {
    positioningSpot () {
      if(this.type === 'invisible'){
        return 'background:none;border:none;border-radius:0px;top: ' + this.y + 'px; left: ' + this.x + 'px; width: '+ this.w + 'px; height: '+ this.h+'px;'
      }else{
        return 'top: ' + this.y + 'px; left: ' + this.x + 'px'
      }
    },
    classType(){
      if(this.type == 'product'){
        return 'fa fa-plus'
      }else if(this.type == 'link'){
        return 'fa fa-link'
      }else{
        return 'invisible'
      }
    }
  },
  methods: {
    goToContent (ev) {
      ev.stopPropagation()
      ev.preventDefault()
      let content = ev.currentTarget.querySelector('a').attributes.href.nodeValue
      let productData = {}
      if(this.content != 0){
      productData = this.$parent.$parent.$parent.productsData[this.content]
      }
      if (this.type === 'product') {
        dataLayer.push({
            'event': 'promotionClick',
            'ecommerce': {
              'promoClick': {
                'promotions': [
                {
                  'id': this.ambient ? 'Ambientada ' + this.indice : 'fullwidth ' + this.indice,
                  'name': `${productData.sku}/${productData.title}`,                     // Nombre de la imagen
                  'creative': this.image ? this.image : '',             // URL de la imagen
                  'position': this.category+'/module '+this.indice               // Nombre de la sección + la posición
                }]
              }
            }
        });
        this.$parent.$parent.$parent.openDetail(this.content)
      } else if(this.type === 'link'){
        dataLayer.push({
            'event': 'promotionClick',
            'ecommerce': {
              'promoClick': {
                'promotions': [
                {
                  'id': this.ambient ? 'Link externo en ambientada' : 'Link externo en fullwidth',                         // Nomenclatura del espacio de la imagen
                  'name': this.image,                     // Nombre de la imagen
                  'creative': this.image,             // URL de la imagen
                  'position': `${this.category}/modulo ${this.indice}`
                }]
              }
            }
        });
        window.open(content,'_blank')
        
      }else{
        window.location = content
      }
      
    }
  },
  data () {
    return {
      test: 'Test'
    }
  },
  mounted () {
    /* setTimeout(function (){
      let imgz = document.getElementById('ambient0')
    let finalWidth = imgz.width
    let finalHeight = imgz.height
    //this.x = Math.round((this.ancho * this.x) / finalWidth)
    //this.y = Math.round((this.alto * this.x) / finalHeight)
    },1000) */
  }
}
</script>
<style>
  .hotspot{position:absolute;z-index:100;background-color:rgba(255,255,255,.7);border-radius:40px;width:40px;height:40px;line-height:42px;border:solid 2px #000}
  .hotspot a{ color:#000;font-size:1.250em }
</style>



// WEBPACK FOOTER //
// src/components/HotSpotComponent.vue